<template>
    <button id="modal_button" type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modal"
        v-show="false"></button>

    <div class="modal fade" id="modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-custom">
            <div class="modal-content d-flex flex-column modal-container">
                <div class="d-flex header justify-content-between">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">{{ props.header }}</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="content" v-html="props.body">
                </div>
                <div class="footer d-flex justify-content-center">
                    <a @click="onButtonClick" type="button" class="btn add-to-cart-button align-self-end">{{ props.buttonText
                        }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, defineExpose } from 'vue';

const props = defineProps({
    header: {
        type: String,
        required: true
    },
    body: {
        type: String,
        required: true
    },
    buttonText: {
        type: String,
        required: true
    }
});

const emit = defineEmits([
    'onButtonClick'
]);

defineExpose({
    show
});

function show() {
    const modalButton = document.getElementById('modal_button');
    modalButton?.click();
}

function onButtonClick() {
    emit('onButtonClick');
}

</script>

<style scoped>
.modal-dialog-custom {
    padding-left: 8px;
    padding-right: 8px;
}

.modal-container {
    padding: 16px;
    gap: 38px;
}

.header {
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 16px;
    font-weight: 500;
}

.header * {
    display: inline;
}

.content {
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 14px;
    font-weight: 400;
}

.add-to-cart-button {
    background-color: #FF057D;
    width: 160px;
    border-radius: 36px;
    padding-top: 12px;
    padding-bottom: 12px;
    font-family: 'Noto Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: white;
}

.add-to-cart-button:hover {
    background-color: #CC4173;
    color: white;
}
</style>
